import { render, staticRenderFns } from "./MyCourse.vue?vue&type=template&id=1191f80a&scoped=true"
import script from "./MyCourse.vue?vue&type=script&lang=js"
export * from "./MyCourse.vue?vue&type=script&lang=js"
import style0 from "./MyCourse.vue?vue&type=style&index=0&id=1191f80a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1191f80a",
  null
  
)

export default component.exports